import { Component, NgZone, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddPartnerComponent } from './add-partner/add-partner.component';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss'
})
export class PartnersComponent implements OnInit {
  countries: any[] = [];

  count = 0;
  apiUrl: any;
  gridApi: any;
  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  columnDefs: ColDef[] = [
        {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },

    {
      headerName: 'Logo',
      field: 'logoPath',
      editable: false,
      filter: false,
      width: 90,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
      cellRenderer: (params: any) => {
        if (params.value) {
          const img = document.createElement('img');
          img.src = params.value;
          img.style.height = '34px';
          img.style.objectFit = 'contain';
          img.style.borderRadius = '4px';
          return img;
        }
        const dash = document.createElement('span');
        dash.style.color = '#aaa';
        dash.innerText = '—';
        return dash;
      }
    },
    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Type',
      field: 'type',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Commission',
      field: 'commission',
      editable: false,
      filter: false,
      width: 200,
      cellRenderer: (params: any) => {
        const data = params.data;
        if (!data) return document.createTextNode('—');
        const service = data.services;
        const wrapper = document.createElement('div');
        wrapper.style.display = 'flex';
        wrapper.style.flexDirection = 'column';
        wrapper.style.justifyContent = 'center';
        wrapper.style.gap = '2px';
        wrapper.style.lineHeight = '1.4';

        if (service === 'PAYMENT' || service === 'BOTH') {
          const line = document.createElement('span');
          line.style.fontSize = '12px';
          const label = document.createElement('span');
          label.className = 'text-muted';
          label.textContent = 'Payment: ';
          const value = document.createElement('strong');
          value.textContent = (data.commission ?? '—') + ' %';
          line.appendChild(label);
          line.appendChild(value);
          wrapper.appendChild(line);
        }
        if (service === 'REMITTANCE' || service === 'BOTH') {
          const line = document.createElement('span');
          line.style.fontSize = '12px';
          const label = document.createElement('span');
          label.className = 'text-muted';
          label.textContent = 'Remittance: ';
          const value = document.createElement('strong');
          value.textContent = (data.remittanceCommission ?? '—') + ' %';
          line.appendChild(label);
          line.appendChild(value);
          wrapper.appendChild(line);
        }
        if (!service) {
          wrapper.appendChild(document.createTextNode('—'));
        }
        return wrapper;
      }
    },
    {
      headerName: 'Account Number',
      field: 'accountNumber',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Routing Number',
      field: 'routingNumber',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Origination Country',
      field: 'originationCountryId',
      editable: false,
      filter: true,
      valueGetter: (params: any) => {
        if (params.data && params.data.originationCountryId && this.countries.length > 0) {
          const originationCountryId = typeof params.data.originationCountryId === 'object' 
            ? params.data.originationCountryId._id 
            : params.data.originationCountryId;
          const country = this.countries.find(c => c._id === originationCountryId);
          return country ? (country.displayName || country.name) : originationCountryId;
        }
        return '';
      }
    },
    {
      headerName: 'Services',
      field: 'services',
      editable: false,
      filter: true,
      width: 130,
      cellRenderer: (params: any) => {
        if (!params.value) return document.createTextNode('—');
        const badge = document.createElement('span');
        const colorMap: any = { PAYMENT: 'bg-primary', REMITTANCE: 'bg-info', BOTH: 'bg-success' };
        badge.classList.add('badge', colorMap[params.value] || 'bg-secondary');
        badge.style.fontSize = '12px';
        badge.innerText = params.value;
        return badge;
      }
    },

  ];

  constructor(private modalService: NgbModal,
    private _api: ApiService,
    private zone: NgZone,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.getCountries();
  }

  getCountries() {
    const vm = this;
    const type = 'country';
    const apiUrl = '/admin/get-data?type=' + type + '&_limit=500';
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error && res.data) {
        // Check if countries are directly in res.data or in res.data.countries
        if (Array.isArray(res.data)) {
          vm.countries = res.data;
        } else if (res.data.countries && Array.isArray(res.data.countries)) {
          vm.countries = res.data.countries;
        }
        // Refresh the grid to update country names
        if (vm.gridApi) {
          setTimeout(() => {
            vm.gridApi.refreshInfiniteCache();
          }, 100);
        }
      }
    });
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    vm.gridApi.sizeColumnsToFit();
  }


  addNew() {
    const vm = this;
    const modalRef = vm.modalService.open(AddPartnerComponent, { backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.onSave.subscribe(() => {
      vm.gridApi.refreshInfiniteCache();
    });
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/admin/partners/' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onEdit(params: any) {
    const vm = this;
    vm.zone.run(() => {
      const modalRef = this.modalService.open(AddPartnerComponent, { backdrop: 'static', size: 'lg' });
      modalRef.componentInstance.newPartner = params.data;
      modalRef.componentInstance.onSave.subscribe(() => {
        vm.gridApi.refreshInfiniteCache();
      });
    });
  }


}